export const formatBooleanToText = (value: boolean): string => {
  return value ? "Yes" : "No";
};
